import { cn } from '@/lib/utils.ts'

export const Reported = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1755_11671)">
        <path
          d="M1.33333 8H0C0 7.26667 0.1 6.54 0.293333 5.84L1.58 6.2C1.42 6.78 1.33333 7.38667 1.33333 8ZM4.63333 2.24667L3.96 1.1C2.78 1.79333 1.78667 2.78667 1.09333 3.96667L2.24667 4.64C2.82667 3.65333 3.65333 2.82667 4.63333 2.24667ZM8 1.33333V0C7.26667 0 6.54 0.1 5.84 0.293333L6.2 1.58C6.78 1.42 7.38667 1.33333 8 1.33333ZM8 14.6667C7.38667 14.6667 6.78 14.5867 6.2 14.42L5.84 15.7067C6.54 15.9 7.26667 16 8 16V14.6667ZM4.63333 13.7533C3.64667 13.1733 2.82 12.3467 2.24 11.3667L1.09333 12.04C1.78667 13.22 2.78 14.2133 3.96 14.9067L4.63333 13.7533ZM1.58 9.8C1.42 9.22 1.33333 8.61333 1.33333 8H0C0 8.73333 0.1 9.46 0.293333 10.16L1.58 9.8ZM16 8H14.6667C14.6667 8.61333 14.5867 9.22 14.42 9.8L15.7067 10.16C15.9 9.46 16 8.73333 16 8ZM14.9067 12.04L13.7533 11.3667C13.1733 12.3533 12.3467 13.18 11.3667 13.76L12.04 14.9067C13.22 14.2133 14.2133 13.22 14.9067 12.04ZM10.16 15.7067L9.8 14.42C9.22 14.58 8.61333 14.6667 8 14.6667V16C8.73333 16 9.46 15.9 10.16 15.7067ZM10.16 0.293333C9.46 0.1 8.73333 0 8 0V1.33333C8.61333 1.33333 9.22 1.41333 9.8 1.58L10.16 0.293333ZM14.9067 3.96C14.2133 2.78 13.22 1.78667 12.04 1.09333L11.3667 2.24667C12.3533 2.82667 13.18 3.65333 13.76 4.63333L14.9067 3.96ZM15.7067 5.84L14.42 6.2C14.58 6.78 14.6667 7.38667 14.6667 8H16C16 7.26667 15.9 6.54 15.7067 5.84Z"
          fill="#18181B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1755_11671">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Done = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_25_27224)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.55544 14.6518C4.87104 15.5308 6.41775 16 8 16C10.121 15.9977 12.1545 15.1541 13.6543 13.6543C15.1541 12.1545 15.9977 10.121 16 8C16 6.41775 15.5308 4.87104 14.6518 3.55544C13.7727 2.23985 12.5233 1.21447 11.0615 0.608967C9.59966 0.00346629 7.99113 -0.15496 6.43928 0.153721C4.88743 0.462403 3.46197 1.22433 2.34315 2.34315C1.22433 3.46197 0.462403 4.88743 0.153721 6.43928C-0.15496 7.99113 0.00346629 9.59966 0.608967 11.0615C1.21447 12.5233 2.23985 13.7727 3.55544 14.6518ZM4.2962 2.45687C5.39253 1.72433 6.68146 1.33334 8 1.33334C9.76752 1.33528 11.4621 2.03828 12.7119 3.2881C13.9617 4.53792 14.6647 6.23249 14.6667 8C14.6667 9.31855 14.2757 10.6075 13.5431 11.7038C12.8106 12.8001 11.7694 13.6546 10.5512 14.1592C9.33305 14.6638 7.99261 14.7958 6.6994 14.5386C5.4062 14.2813 4.21831 13.6464 3.28596 12.714C2.35361 11.7817 1.71867 10.5938 1.46144 9.30061C1.2042 8.0074 1.33622 6.66695 1.84081 5.44878C2.34539 4.23061 3.19987 3.18942 4.2962 2.45687ZM13 8C13 5.23858 10.7614 3 8 3L8 8H3C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8Z"
          fill="#3AD199"
        />
      </g>
      <defs>
        <clipPath id="clip0_25_27224">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const InProgress = ({ className }: { className?: string }) => {
  return (
    <svg
      className={cn(``, className)}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_6618_34542)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.55544 14.6518C4.87104 15.5308 6.41775 16 8 16C10.121 15.9977 12.1545 15.1541 13.6543 13.6543C15.1541 12.1545 15.9977 10.121 16 8C16 6.41775 15.5308 4.87104 14.6518 3.55544C13.7727 2.23985 12.5233 1.21447 11.0615 0.608967C9.59966 0.00346629 7.99113 -0.15496 6.43928 0.153721C4.88743 0.462403 3.46197 1.22433 2.34315 2.34315C1.22433 3.46197 0.462403 4.88743 0.153721 6.43928C-0.15496 7.99113 0.00346629 9.59966 0.608967 11.0615C1.21447 12.5233 2.23985 13.7727 3.55544 14.6518ZM4.2962 2.45687C5.39253 1.72433 6.68146 1.33334 8 1.33334C9.76752 1.33528 11.4621 2.03828 12.7119 3.2881C13.9617 4.53792 14.6647 6.23249 14.6667 8C14.6667 9.31855 14.2757 10.6075 13.5431 11.7038C12.8106 12.8001 11.7694 13.6546 10.5512 14.1592C9.33305 14.6638 7.99261 14.7958 6.6994 14.5386C5.4062 14.2813 4.21831 13.6464 3.28596 12.714C2.35361 11.7817 1.71867 10.5938 1.46144 9.30061C1.2042 8.0074 1.33622 6.66695 1.84081 5.44878C2.34539 4.23061 3.19987 3.18942 4.2962 2.45687ZM8 3V6L8 8V13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3Z"
          fill="#FFBF42"
        />
      </g>
      <defs>
        <clipPath id="clip0_6618_34542">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Approved = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1755_11710)">
        <path
          d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM8 10L7.00133 11L6 10L4 8L5 7L7.00133 9L11 5L12 6L8 10Z"
          fill="#976CDF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1755_11710">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const OnHold = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1755_4425)">
        <path
          d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM7 11H5V5H7V11ZM11 11H9V5H11V11Z"
          fill="#FF7B60"
        />
      </g>
      <defs>
        <clipPath id="clip0_1755_4425">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Abandoned = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1755_4628)">
        <path
          d="M16 8C16 12.4113 12.4113 16 8 16C3.58867 16 0 12.4113 0 8C0 3.58867 3.58867 0 8 0C12.4113 0 16 3.58867 16 8ZM11 5H5V11H11V5Z"
          fill="#18181B"
          fillOpacity="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1755_4628">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Waiting = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1755_9446)">
        <path
          d="M8 16C6.41775 16 4.87104 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346629 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153721C7.99113 -0.15496 9.59966 0.00346629 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87104 16 6.41775 16 8C15.9977 10.121 15.1541 12.1545 13.6543 13.6543C12.1545 15.1541 10.121 15.9977 8 16ZM8 1.33334C6.68146 1.33334 5.39253 1.72433 4.2962 2.45687C3.19987 3.18942 2.34539 4.23061 1.84081 5.44878C1.33622 6.66695 1.2042 8.0074 1.46144 9.30061C1.71867 10.5938 2.35361 11.7817 3.28596 12.714C4.21831 13.6464 5.4062 14.2813 6.6994 14.5386C7.99261 14.7958 9.33305 14.6638 10.5512 14.1592C11.7694 13.6546 12.8106 12.8001 13.5431 11.7038C14.2757 10.6075 14.6667 9.31855 14.6667 8C14.6647 6.23249 13.9617 4.53792 12.7119 3.2881C11.4621 2.03828 9.76752 1.33528 8 1.33334Z"
          fill="#18181B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1755_9446">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Dead = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1755_24461)">
        <path
          d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346631 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM12 11L11 12L8 8.94267L5 12L4 11L7 8L4 5L5 4L8 7L11 4L12 5L8.94267 8L12 11Z"
          fill="#18181B"
          fillOpacity="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1755_24461">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Competitor = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1755_4720)">
        <path
          d="M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM12 9H4V7H12V9Z"
          fill="#FF7B60"
        />
      </g>
      <defs>
        <clipPath id="clip0_1755_4720">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const Positive = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="8" fill="#3AD199" />
      <path
        d="M8.85167 4.89123L8.66667 6.00056H12V7.00056L11.3333 10.6672H6.66667V6.00056L7.46367 4.40823C7.55047 4.23834 7.69882 4.10797 7.87846 4.04373C8.0581 3.9795 8.25549 3.98623 8.43033 4.06256C8.58279 4.13407 8.70702 4.25442 8.78334 4.40452C8.85966 4.55463 8.88371 4.72591 8.85167 4.89123Z"
        fill="white"
      />
      <path
        d="M5 6.00056H6V10.6672H5C4.73478 10.6672 4.48043 10.5619 4.29289 10.3743C4.10536 10.1868 4 9.93245 4 9.66723V7.00056C4 6.73535 4.10536 6.48099 4.29289 6.29346C4.48043 6.10592 4.73478 6.00056 5 6.00056Z"
        fill="white"
      />
    </svg>
  )
}

export const Negative = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="8" fill="#FF7B60" />
      <path
        d="M6 5.33008H5C4.73478 5.33008 4.48043 5.43543 4.29289 5.62297C4.10536 5.81051 4 6.06486 4 6.33008V8.99674C4 9.26196 4.10536 9.51632 4.29289 9.70385C4.48043 9.89139 4.73478 9.99675 5 9.99675H6V5.33008Z"
        fill="white"
      />
      <path
        d="M12 8.99674L11.3333 5.33008H6.66667V9.99675L7.447 11.5571C7.49376 11.6581 7.56196 11.7478 7.64687 11.8198C7.73178 11.8918 7.83135 11.9444 7.93867 11.9741C8.05735 12.0056 8.18203 12.0071 8.30142 11.9783C8.42082 11.9496 8.53115 11.8915 8.62245 11.8094C8.71375 11.7272 8.78313 11.6236 8.82432 11.5079C8.86551 11.3922 8.8772 11.2681 8.85833 11.1467L8.66667 9.99675H12V8.99674Z"
        fill="white"
      />
    </svg>
  )
}

export const None = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1755_26514)">
        <path
          d="M8 16C6.41775 16 4.87104 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346629 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153721C7.99113 -0.15496 9.59966 0.00346629 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87104 16 6.41775 16 8C15.9977 10.121 15.1541 12.1545 13.6543 13.6543C12.1545 15.1541 10.121 15.9977 8 16ZM8 1.33334C6.68146 1.33334 5.39253 1.72433 4.2962 2.45687C3.19987 3.18942 2.34539 4.23061 1.84081 5.44878C1.33622 6.66695 1.2042 8.0074 1.46144 9.30061C1.71867 10.5938 2.35361 11.7817 3.28596 12.714C4.21831 13.6464 5.4062 14.2813 6.6994 14.5386C7.99261 14.7958 9.33305 14.6638 10.5512 14.1592C11.7694 13.6546 12.8106 12.8001 13.5431 11.7038C14.2757 10.6075 14.6667 9.31855 14.6667 8C14.6647 6.23249 13.9617 4.53792 12.7119 3.2881C11.4621 2.03828 9.76752 1.33528 8 1.33334Z"
          fill="#18181B"
          fillOpacity="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_1755_26514">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
